// Thin fetch wrapper. Always sends cookies so the session works.
//
// In dev, Vite's proxy forwards /admin/* to :8082 — paths stay relative
// and the browser sees a same-origin request. In production on
// Cloudflare Pages, `getApiBase()` returns the absolute admin BE URL
// (sourced from VITE_ADMIN_API_URL at build time) so the FE talks to
// the BE directly. The admin BE host shares the registrable domain
// with the FE (e.g. propwise-admin / propwise-admin-api . algonavis.com),
// so the request is same-site cross-origin and the session cookie
// with SameSite=Lax is sent without further configuration.

import { getApiBase } from "./config";

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const url = `${getApiBase()}${path}`;
  const res = await fetch(url, {
    method,
    credentials: "include",
    headers: body == null ? undefined : { "content-type": "application/json" },
    body: body == null ? undefined : JSON.stringify(body),
  });
  const text = await res.text();
  let data: any = undefined;
  if (text) {
    try { data = JSON.parse(text); } catch { /* non-JSON */ }
  }
  if (!res.ok) {
    const msg = (data && (data.error || data.message)) || res.statusText || "request failed";
    throw new ApiError(res.status, msg);
  }
  return data as T;
}

export const api = {
  get:   <T = unknown>(p: string)               => request<T>("GET",    p),
  post:  <T = unknown>(p: string, b?: unknown)  => request<T>("POST",   p, b),
  patch: <T = unknown>(p: string, b?: unknown)  => request<T>("PATCH",  p, b),
  del:   <T = unknown>(p: string)               => request<T>("DELETE", p),
};
